import styled, { css } from 'styled-components';
import { ReactComponent as _EditorIcon } from 'styles/icons/highlight.svg';
import { ReactComponent as _DeleteIcon } from 'styles/icons/delete-icon.svg';
import { ReactComponent as _CheckIcon } from 'styles/icons/check-icon-filled.svg';

import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';

const iconStyles = css`
  opacity: 0.9;
  cursor: pointer;
  transform: scale(0.9);
  position: relative;
`;

export const Container = styled.div`
  border-radius: 2px 10px 2px 2px;
  position: relative;
  left: ${(props) => props.offset || 0}px;
  top: calc(100%);
  width: 257px;
  height: 61px;
  border: 1px solid #e5e5e5;
  background-color: white;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.08);
  cursor: default;
  margin-left: 5px;
  /* z-index: 100; */
`;

export const TextArea = styled.textarea`
  font-size: 12px;
  line-height: 12px;
  color: #1c1b18;
  font-family: 'Montserrat', sans-serif;
  width: 150px;
  height: 31px;
  resize: none;
  border: none;
  padding: 5px;
  padding-top: 8px;

  :placeholder {
  }
`;

export const DeleteIcon = styled(_DeleteIcon)`
  ${iconStyles};
  width: 24px;
  height: 26px;
  :hover {
    color: ${color.ui.danger};
  }
`;
//color: #3c6948;
export const CheckIcon = styled(_CheckIcon)`
  ${iconStyles};
  color: #3c6948;
`;

export const EditIcon = styled(_EditorIcon)`
  ${iconStyles};
`;

export const SnippetFormControls = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
  top: 15px;
  padding-left: 15px;
  position: relative;
  justify-content: space-around;
  align-items: center;

  ${withModifiers('$preview')`
    width: 60px;
  `}
`;

export const SnippetNameContainer = styled.p`
  width: 180px;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 15px;
  resize: none;
  border: none;
  margin: 0;
  text-align: left;
  line-height: 1em;
  padding-left: 10px;
`;
